import axios from "axios";
import { ExamType } from "types/examType";
import { PatientReturnStatus } from "types/patientReturnStatus";

interface GetSlotsCreatorArgs {
  officeId: string;
  startDate: string;
  endDate: string;
  examType?: ExamType;
  doctorIds: string[];
  patientReturnStatus: PatientReturnStatus;
  rsl?: boolean;
}

export interface GetSlotsResponse {
  date: string;
  start_time: string;
  end_time: string;
  doctor_id: string;
  time_zone_name: string;
}

export const getSlotMetaData = async ({
  officeId,
  doctorIds,
  startDate,
  endDate,
  examType,
  patientReturnStatus,
  rsl,
}: GetSlotsCreatorArgs): Promise<any> => {
  const slotsResult = await axios.get<any>(
    `/api/offices/${officeId}/meta_data_time_slots`,
    {
      params: {
        exam_type: examType,
        patient_return_status: patientReturnStatus,
        doctor_ids: doctorIds,
        start_date: startDate,
        end_date: endDate,
        rsl: rsl === true ? true : false,
      },
    }
  );

  return slotsResult.data.slots_meta_data;
};
